<template>

  <div class="container">

    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <b-field
            label="Start date"
            custom-class="is-small"
          >
            <b-datepicker
              placeholder="Start date..."
              icon="calendar-today"
              v-model="$store.state.evaluationUsageFilter.startDate"
              @keyup.enter="filterProperties()"
            ></b-datepicker>
          </b-field>
        </div>
        <div class="level-item">
          <b-field
            label="End date"
            custom-class="is-small"
          >
            <b-datepicker
              placeholder="End date..."
              icon="calendar-today"
              v-model="$store.state.evaluationUsageFilter.endDate"
              @keyup.enter="filterProperties()"
            ></b-datepicker>
          </b-field>
        </div>
        <div class="level-item">
          <b-field
            label="."
            custom-class="is-small"
          >
            <button
              class="button is-primary"
              @click="refresh()"
            >Update</button>
          </b-field>
        </div>
      </div>
    </div>

    <div class="level">
      <div class="column">
        <nav class="level level-right">
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Discovery Count</p>
              <p class="title">{{ $store.state.evaluationUsage.evaluationDiscoveryCount }}</p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Quest Count</p>
              <p class="title">{{ $store.state.evaluationUsage.evaluationQuestCount }}</p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Discovery Portion</p>
              <p class="title">{{ $store.state.evaluationUsage.evaluationDiscoveryPercent | percent(0) }} </p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Quest Portion</p>
              <p class="title">{{ $store.state.evaluationUsage.evaluationQuestPercent | percent(0) }} </p>
            </div>
          </div>
        </nav>
      </div>
    </div>

    <div class="level">
      <div class="column">
        <nav class="level level-right">
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Evaluations Count</p>
              <p class="title">{{ $store.state.evaluationUsage.evaluationCount }}</p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Properties Count</p>
              <p class="title">{{ $store.state.evaluationUsage.propertyCount }}</p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Notes Count</p>
              <p class="title">{{ $store.state.evaluationUsage.notesCount }}</p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Documents Count</p>
              <p class="title">{{ $store.state.evaluationUsage.documentsCount }}</p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Connections Count</p>
              <p class="title">{{ $store.state.evaluationUsage.connectionsCount }}</p>
            </div>
          </div>
        </nav>
      </div>
    </div>

    <div class="section">
      <div class="columns">
        <div class="column">
          <b-table
            narrowed
            :data="$store.state.evaluationUsage.marketCounts"
            :columns="marketColumns"
          ></b-table>
        </div>
        <div class="column">
          <b-table
            narrowed
            :data="$store.state.evaluationUsage.stageCounts"
            :columns="stageColumns"
          ></b-table>
        </div>
        <div class="column">
        </div>
        <div class="column">
        </div>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  data() {
    return {
      marketColumns: [
        {
          field: "mlsMarket",
          label: "Market",
          numeric: false
        },
        {
          field: "count",
          label: "#",
          numeric: true
        }
      ],
      stageColumns: [
        {
          field: "stage",
          label: "Stage",
          numeric: false
        },
        {
          field: "count",
          label: "#",
          numeric: true
        }
      ]
    };
  },

  mounted() {
    if (this.$store.getters.session) this.refresh();
  },

  methods: {
    refresh() {
      console.log("refresh()");
      var startDate = this.$store.state.evaluationUsageFilter.startDate;
      var endDate = this.$store.state.evaluationUsageFilter.endDate;
      console.log("startDate, endDate", startDate, endDate);
      this.$store.dispatch("getEvaluationUsage", { startDate, endDate });
    }
  }
};
</script>

<style>
</style>
